// @flow

import * as React from "react";
import CalibrationChart from "./CalibrationChart";

const exampleData = [
  {
    confidence: 0,
    mean: 10,
    stdev: 10
  },
  {
    confidence: 10,
    mean: 20,
    stdev: 20
  },
  {
    confidence: 20,
    mean: 30,
    stdev: 20
  },
  {
    confidence: 30,
    mean: 30,
    stdev: 25
  },
  {
    confidence: 40,
    mean: 30,
    stdev: 20
  },
  {
    confidence: 50,
    mean: 35,
    stdev: 15
  },
  {
    confidence: 60,
    mean: 50,
    stdev: 20
  },
  {
    confidence: 70,
    mean: 50,
    stdev: 20
  },
  {
    confidence: 80,
    mean: 60,
    stdev: 10
  },
  {
    confidence: 90,
    mean: 70,
    stdev: 20
  },
  {
    confidence: 100,
    mean: 80,
    stdev: 20
  }
];

const ExampleCalibrationChart = () => {
  return <CalibrationChart data={exampleData} />;
};

export default ExampleCalibrationChart;



// WEBPACK FOOTER //
// ./src/components/CalibrationChart/Example.js